import { contactFormApi } from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { contactActions } from "./actions";

export function* contactSaga() {
    yield takeEveryFsa(contactActions.contactForm.started, function* (action) {
        yield* makeAsyncApiCall(action, contactActions.contactForm, contactFormApi )
    })
}